<template lang="pug">
modal#delete-team-user-modal(
  :buttonColor='buttonColor'
  :close-button-label='$t("modal.deleteTeamUser.closeButtonLabel")'
  :loading='loading'
  :process-button-label='$t("modal.deleteTeamUser.processButtonLabel")'
  :title='$t("modal.deleteTeamUser.title")'
  @process='deleteTeamUser'
  processButtonClass='btn-danger'
  ref='modal'
  size='sm'
)
  p(v-html='$t("modal.deleteTeamUser.message")')
  p(v-html='$t("modal.deleteTeamUser.messageSure")')
  img.d-flex.m-auto.mt-5.text-center(
    src='/img/ilustrations/contact-delete-warning.svg'
  )
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import TeamsService from '@/modules/account/services/http/TeamsService';
import alert from '@/modules/account/common/alert';

export default {
  name: 'DeleteTeamUserModal',
  components: { Modal },
  props: {
    teamId: String,
    userId: String,
  },
  data() {
    return {
      loading: false,
      buttonColor: true,
    };
  },
  methods: {
    deleteTeamUser() {
      this.$loading(true);
      TeamsService.deleteUser(this.teamId, this.userId)
        .then(() => {
          this.$emit('refresh');
          this.loading = false;
          this.$refs.modal.close();
          alert.fireAlert(this.$t('modal.deleteTeamUser.deletedUser'), {
            styles:
              'background-color: #D4EDDA; border: solid 1px #AACFB3; color: #0F6642;',
            icon: 'circle-check',
          });
        })
        .catch((error) => {
          alert.fireAlert(
            `${this.$t('modal.deleteTeamUser.error')} ${
              error.response.data.message
            }`,
            {
              classes: 'alert-danger',
              styles:
                'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
              tag: 'httpAlert',
              icon: 'circle-exclamation',
            }
          );
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>
